export const VISIT_CRAWLER_APP = 'visit_crawler_system'
export const EDIT_CRAWLER_TASK = 'edit_crawler_task'
export const CREATE_CRAWLER_TASK = 'create_crawler_task'
export const EXEC_CRAWLER_TASK = 'exec_crawler_task'
export const REMOVE_CRAWLER_TASK = 'remove_crawler_task'
